import { isEmpty } from '@sgme/fp';
import { Box, HStack, VStack } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useState } from 'react';

import RightColumnHeader from '@/App/tiles/ForwardAccumulator/parts/RightColumnHeader.tsx';
import { InputGroup1 } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/InputGroup1.tsx';
import { InputGroup2 } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/InputGroup2.tsx';
import { InputGroup3 } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/InputGroup3.tsx';
import { InputGroup4 } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/InputGroup4.tsx';
import Header from '@/App/tiles/ForwardAccumulator/parts/RightPanel/Scheduler/Header/index.tsx';
import { NoSchedule } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/Scheduler/NoSchedule.tsx';
import SchedulerTable from '@/App/tiles/ForwardAccumulator/parts/RightPanel/Scheduler/Table/index.tsx';
import { useForwardAccumulatorSelector } from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';

const UnzoomedTileSchedulerView = () => {
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const hasSchedule = useForwardAccumulatorSelector(
    (forwardAccumulator) => !isEmpty(forwardAccumulator.properties.scheduleIds),
  );

  const [parametersAreVisible, setParametersAreVisible] = useState(true);

  return (
    <VStack flex="expand" verticalAlignment="start" className="align-self-stretch">
      <RightColumnHeader />
      <VStack flex="expand" verticalAlignment="start">
        <Box flex="min" className="mx-3 my-1 border">
          <HStack
            onClick={() => {
              sgwtWebAnalytics?.trackEvent(
                'Forward Accumulator',
                parametersAreVisible ? 'Parameters hidden' : 'Parameters shown',
              );
              setParametersAreVisible(!parametersAreVisible);
            }}
            className="cursor-pointer p-2"
          >
            <span className="active ms-16px mb-8px fw-semibold">Schedule parameters</span>
            <button type="button" className="btn btn-sm btn-link btn-icon-text pe-0">
              <i className="icon icon-sm line-height-1 btn-group text-xxlarge ms-auto">
                {parametersAreVisible ? 'unfold_less' : 'unfold_more'}
              </i>
            </button>
          </HStack>
          {parametersAreVisible && (
            <HStack verticalAlignment="start" gap="4px" className="px-2 pb-2">
              <VStack className="px-1 w-50">
                <div>
                  <InputGroup1 />
                </div>
                <div className="mt-2">
                  <InputGroup2 />
                </div>
              </VStack>
              <VStack verticalAlignment="start" className="px-1 w-50">
                <div>
                  <InputGroup3 useShortLabels />
                </div>
                <div className="mt-2">
                  <InputGroup4 />
                </div>
              </VStack>
            </HStack>
          )}
        </Box>
        {hasSchedule ? (
          <Box flex="expand" className="border m-3 mt-1">
            <Header parametersAreVisible={parametersAreVisible} setParametersAreVisible={setParametersAreVisible} />
            <SchedulerTable keepSmall={parametersAreVisible} />
          </Box>
        ) : (
          <Box flex="expand" className="m-3 mt-1 p-2 border">
            <NoSchedule />
          </Box>
        )}
      </VStack>
    </VStack>
  );
};

export default UnzoomedTileSchedulerView;
